import everyInspectionList from './inspectionList.vue'
import everyInventoryList from './inventoryList.vue'
import everyEngineerList from './list.vue'

let a = Object.assign({ everyInspectionList, everyInventoryList, everyEngineerList })
export default a